import { ListElement } from '@components/std-components/SelectComponent'
import React, { FC } from 'react'

const DropdownListContainer: FC<ListElement> = ({ children }) => {
  return <div className='flex column'>{children}</div>
}

export default DropdownListContainer
